const PaperGenerationControl = {
    QUESTION_LIST: { name: 'Question', path: '/question-list' },
    ADD_QUESTION: { name: 'Add Question', path: '/add-question' },
    UPDATE_QUESTION: { name: 'Update Question', path: '/edit-question' },
    DELETE_QUESTION: { name: 'Delete Question', path: '/delete-question' },

    QUESTION_BANK_LIST: { name: 'Question Bank', path: '/question-bank-list' },
    ADD_QUESTION_BANK: { name: 'Add Question Bank', path: '/add-question-bank' },
    UPDATE_QUESTION_BANK: { name: 'Update Question Bank', path: '/edit-question-bank' },
    DELETE_QUESTION_BANK: { name: 'Delete Question Bank', path: '/delete-question-bank' },
    QUESTION_BANK_DETAILS: { name: 'Question Bank Details', path: '/question-bank-details' },

    EXAM_LIST: { name: 'Exam', path: '/exam-list' },
    ADD_EXAM: { name: 'Add Exam', path: '/add-exam' },
    UPDATE_EXAM: { name: 'Update Exam', path: '/edit-exam' },
    DELETE_EXAM: { name: 'Delete Exam', path: '/delete-exam' },
    EXAM_DETAILS: { name: 'Exam Details', path: '/exam-details' },

    EXAM_QUESTION_LIST: { name: 'Exam Question', path: '/exam-question-list' },
    ADD_EXAM_QUESTION: { name: 'Add Exam Question', path: '/add-exam-question' },
    UPDATE_EXAM_QUESTION: { name: 'Update Exam Question', path: '/edit-exam-question' },
    DELETE_EXAM_QUESTION: { name: 'Delete Exam Question', path: '/delete-exam-question' },

    EXAM_INVITATION_LIST: { name: 'Exam Invitation', path: '/exam-invitation-list' },
    ADD_EXAM_INVITATION: { name: 'Add Exam Invitation', path: '/add-exam-invitation' },
    RESEND_EXAM_INVITATION: { name: 'Resend Exam Invitation', path: '/resend-exam-invitation' },
    DELETE_EXAM_INVITATION: { name: 'Delete Exam Invitation', path: '/delete-exam-invitation' },

};

export default PaperGenerationControl;
